/* eslint-disable no-unused-vars */
import IconsPath from '../../assets/icons.svg';

function DokanListIcons({ icon, color, size = 4, svgStyle }) {
    return (
        <>
            <svg className={`${svgStyle}`} fill={color} width={size} height={size}>
                <use xlinkHref={`${IconsPath}#${icon}`} />
            </svg>
        </>
    );
}

export default DokanListIcons;
